module.exports = __webpack_public_path__ + "static/erp-laptop-screen2-15b53c3037e4aab2158856df646d41e4.jpeg";